import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FiLink } from "react-icons/fi";
import { Modal, Button, FormField, DraftNotice } from "../common";
import useFormDraft from "../../hooks/useFormDraft";
import { addEvidenceLink, linkProblem } from "../../services/evidenceLinkApi";
import { getErrorMessage } from "../../utils/errors";
import Select from "../common/Select"; // [NEW] alphabetical dropdown (replaces <select>)

export default function EvidenceLinkModal({ open, recordId, context = "SELF_ASSESSMENT", items = [], onClose, onAdded }) {
  const [form, setForm] = useState({ url: "", title: "", description: "", itemId: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (open) { setForm({ url: "", title: "", description: "", itemId: "" }); setError(""); } }, [open]);
  const set = (patch) => { setForm((f) => ({ ...f, ...patch })); setError(""); };
  // [NEW] Keep an unfinished evidence link for this appraisal.
  const draft = useFormDraft(`evidence-link:${recordId}:${context}`, form, setForm, { active: open });

  const save = async () => {
    const problem = linkProblem(form.url) || (!form.title.trim() ? "Give the link a short title." : null);
    if (problem) { setError(problem); return; }
    const item = items.find((x) => String(x.id) === String(form.itemId));
    setBusy(true);
    try {
      await addEvidenceLink(recordId, { url: form.url, title: form.title, description: form.description, itemId: item?.id, context: item ? item.type : context });
      toast.success("Link added as evidence.");
      draft.clear();
      onAdded?.();
      onClose();
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      open={open}
      size="sm"
      title="Add a link as evidence"
      subtitle="Links are saved as they are; make sure the reviewer can open them."
      onClose={busy ? undefined : onClose}
      footer={<><Button variant="ghost" onClick={onClose} disabled={busy}>Cancel</Button><Button icon={FiLink} onClick={save} loading={busy}>Add link</Button></>}
    >
      <div className="form-stack">
        <DraftNotice draft={draft} compact />
        <FormField label="Link" required hint="https://... (no user name or password in the link)">
          <input type="url" value={form.url} placeholder="https://" onChange={(e) => set({ url: e.target.value })} />
        </FormField>
        <FormField label="Title" required>
          <input value={form.title} maxLength={300} onChange={(e) => set({ title: e.target.value })} />
        </FormField>
        <FormField label="Description">
          <textarea rows={2} value={form.description} maxLength={5000} onChange={(e) => set({ description: e.target.value })} />
        </FormField>
        {items.length > 0 && (
          <FormField label="Evidence for" hint="Leave empty for the assessment as a whole.">
            <Select value={form.itemId} onChange={(e) => set({ itemId: e.target.value })}>
              <option value="">The whole assessment</option>
              {items.map((x) => <option key={x.id} value={x.id}>{x.type}: {x.title}</option>)}
            </Select>
          </FormField>
        )}
        {error && <p className="form-error">{error}</p>}
      </div>
    </Modal>
  );
}
